export const immutableReverse = (array) => {
  const newArray = [].concat(array || []);
  return newArray.reverse();
};
